import { render, staticRenderFns } from "./ReturnListDetail.vue?vue&type=template&id=7bdc3b63&scoped=true&"
import script from "./ReturnListDetail.vue?vue&type=script&lang=js&"
export * from "./ReturnListDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReturnListDetail.vue?vue&type=style&index=0&id=7bdc3b63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdc3b63",
  null
  
)

export default component.exports